import { DateWithTooltip } from "components/DateWithTooltip";
import PropTypes from "prop-types";
import React from "react";
import { styled } from "@mui/material/styles";

export const NextActionCell = ({ value, width = 100 }) => (
  <CellWithWidthDiv width={width}>
    <span>{value ?? "-"}</span>
  </CellWithWidthDiv>
);

NextActionCell.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.number
};

export const DateCell = ({ value, width = 100 }) => (
  <CellWithWidthDiv width={width}>
    <DateWithTooltip date={value} />
  </CellWithWidthDiv>
);

DateCell.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.number
};

const CellWithWidthDiv = styled("div")`
  width: ${({ width }) => `${width}px`};
`;
